import React, { useEffect, useState } from 'react';
import { Card, Container, ContainerFlex, TextLocalized } from '../components/styled/Styled';
import { HttpConnection, HttpMethod, HttpOperations } from '../components/util/HttpConnection';
import BlockPerformance from '../components/BlockPerformance';

const ImprovementView = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        HttpConnection(`${HttpOperations.block}/score`,
            response => {
                setItems(response.item)
            }, error => console.log(error), HttpMethod.get);
    }, [])

    return (
        <ContainerFlex width="12" justify="center" px="32" >
            <Container width="12" lg="8">
                <Card width="12" shadowOn flex mv="16" px="16" align="center" color="color-green-dark" fontColor="color-white">
                    <Container width="12" fontSize="18px" fontWeight="300" radiusbl="0px" radiusbr="0px" children={<TextLocalized children="msgImprovement" />} />
                    <Container mt="8" fontSize="12px" children={<TextLocalized children="msgImprovementMainSubtitle" />} />
                </Card>

                <Container width="12" mt="32" fontSize="18px" fontWeight="300" fontColor="color-black" children={<TextLocalized children="msgLifecyclePhases" />} />
                <Card width="12" height="5px" mv="16" color="color-green-dark" radius="2px" />
                <ContainerFlex width="12" align="stretch" children={items.slice(1).map((item) => <BlockPerformance key={item.id_block} item={item} url='/improvement/block' />)} />
            </Container>
        </ContainerFlex>
    );
};

export default ImprovementView;